import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.ReportsRequestPage.FilterReferenceList', {
    placeholder: 'Any value',
});

export const airwallexBatchPaymentStatusMessages = defineMessages(
    'app.ReportsRequestPage.FilterReferenceList.BatchPaymentStatus',
    {
        awaitingPayment: 'Awaiting payment',
        failed: 'Failed',
        none: 'None',
        paid: 'Paid',
        partiallyPaid: 'Partially paid',
        processing: 'Processing',
    }
);

export const airwallexBatchPaymentPurposeMessages = defineMessages(
    'app.ReportsRequestPage.FilterReferenceList.BatchPaymentPurpose',
    {
        audio_visual_services: 'Audio visual services',
        business_expenses: 'Business expenses',
        donation_charitable_contribution: 'Donation charitable contribution',
        education_training: 'Education training',
        family_support: 'Family support',
        goods_purchased: 'Goods purchased',
        investment_capital: 'Investment capital',
        investment_proceeds: 'Investment proceeds',
        living_expenses: 'Living expenses',
        loan_credit_repayment: 'Loan credit repayment',
        medical_services: 'Medical services',
        other_services: 'Other services',
        personal_remittance: 'Personal remittance',
        professional_business_services: 'Professional business services',
        real_estate: 'Real estate',
        technical_services: 'Technical services',
        transfer_to_own_account: 'Transfer to own account',
        wages_salary: 'Wages or salary',
    }
);
